import angular from 'angular';
import basketService from '../../services/basket.service';
import basketController from './basket.controller';
import basketModalController from './basketModal.controller';
import basketListController from './basketList.controller';
import basketListItemController from './basketListItem.controller';

export default angular.module('components.basket', [
    basketService
])
    .component('basket', {
        template: require('./basket.pug')(),
        bindings: {
            text: '@',
            docid: '<',
            onDone: '&',
            disabled: '<'
        },
        controller: basketController
    })
    .component('basketModal', {
        template: require('./basketModal.pug')(),
        bindings: {
            modalInstance: '<',
            resolve: '<'
        }, 
        controller: basketModalController
    })
    .component('basketList', {
        template: require('./basketList.pug')(),
        controller: basketListController
    })
    .component('basketListItem', {
        bindings: {
            item: '<'
        },
        template: require('./basketListItem.pug')(),
        controller: basketListItemController
    })
    .value('BasketConfig', {
        catalogid: 1,
        maxSize: 10,
        hitsList: [
            {name: '1', value: 1},
            {name: '5', value: 5},
            {name: '10', value: 10},
            {name: '20', value: 20}
        ],
        itemsPerPage: 5,
        sortKeysList: [
            {name: __('Record key (asc)'), value:'id:asc'},
            {name: __('Record key (desc)'), value:'id:desc'},
            {name: __('Date (asc)'), value:'ctime:asc'},
            {name: __('Date (desc)'), value:'ctime:desc'}
        ]
    })
    .name; 
